import request from '@/utils/request'

export function beforeSSO(params) {
    return request({
      url: '/iot/beforeSSO',
      method: 'get',
      params
    })
  }

  export function afterSSO(params) {
    return request({
      url: '/iot/afterSSO',
      method: 'get',
      params
    })
  }

  export function logout() {
    return request({
      url: '/user/logout',
      method: 'get'
    })
  }